"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _listingType = _interopRequireDefault(require("./listing-type"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var MSiteListingTypeMap = {
  [_listingType.default.RENTAL_RESIDENTIAL.name]: {
    mode: 'rent',
    context: 'residential'
  },
  [_listingType.default.SALES_RESIDENTIAL.name]: {
    mode: 'buy',
    context: 'residential'
  },
  [_listingType.default.RENTAL_COMMERCIAL.name]: {
    mode: 'rent',
    context: 'commercial'
  },
  [_listingType.default.SALES_COMMERCIAL.name]: {
    mode: 'buy',
    context: 'commercial'
  },
  [_listingType.default.SALES_BUSINESS.name]: {
    mode: 'buy',
    context: 'business'
  },
  [_listingType.default.SHARE_RESIDENTIAL.name]: {
    mode: 'share',
    context: 'residential'
  },
  [_listingType.default.DEVELOPMENTS_RESIDENTIAL.name]: {
    mode: 'newdev',
    context: 'residential'
  }
};
var _default = exports.default = MSiteListingTypeMap;